export default function bindMethods(object, methods) {
  methods.forEach((m) => {
    object[m] = object[m].bind(object); // eslint-disable-line no-param-reassign
  });
}
